import { render, staticRenderFns } from "./playerTeam.vue?vue&type=template&id=b2a8931e&scoped=true&"
import script from "./playerTeam.vue?vue&type=script&lang=js&"
export * from "./playerTeam.vue?vue&type=script&lang=js&"
import style0 from "./playerTeam.vue?vue&type=style&index=0&id=b2a8931e&lang=scss&scoped=true&"
import style1 from "./playerTeam.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a8931e",
  null
  
)

export default component.exports